module.exports = __webpack_public_path__ + "img/brain.46f232f1.png";